import classNames from "classnames";
import CopyToClipboard from "react-copy-to-clipboard";
import {toast} from "react-hot-toast";
import {FaRegCopy} from "react-icons/fa";
import {FiAlertTriangle} from "react-icons/fi";

import {Divider} from "@/components/divider/Divider.tsx";
import {FormModal} from "@/components/form/overlay/FormModal.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {
  GLOBAL_STATUS_TITLE_MAP,
  PrivateLocationGlobalStatusCode,
  PrivateLocationWithGlobalStatus,
} from "@/lib/types/monitoring.ts";
import {PropsWithClassName} from "@/lib/types/props.ts";

interface ListSectionProps extends PropsWithClassName {
  listValues: string[];
  title: string;
}

const ListSection = ({listValues, title, className}: ListSectionProps) => {
  if (listValues.length === 0) return null;

  return (
    <>
      <div className="d-flex align-items-center mb-2 pulseTextH3Bold">
        <Icon icon={FiAlertTriangle} className={classNames(className, "pe-2")} /> {title} ({listValues.length})
      </div>
      <ul className="ps-4 pt-2">
        {listValues.map((listValue, index) => (
          <li key={index} dangerouslySetInnerHTML={{__html: listValue}} />
        ))}
      </ul>
    </>
  );
};

interface ExtendedStatusModalProps {
  location: PrivateLocationWithGlobalStatus;
  show: boolean;
  hide: () => void;
}

export const ExtendStatusModal = ({location, show, hide}: ExtendedStatusModalProps) => {
  return (
    <FormModal
      title={`Extended Status: ${location.name}`}
      cancelBtnText={"Close"}
      hasSubmitButton={false}
      onCancel={hide}
      show={show}
      size="lg"
      formId={"extend-status-form"}
    >
      {location.api_token && (
        <>
          <div className={"d-flex align-items-center gap-2"}>
            <strong>API Token:</strong>

            <code className={"pulse-color-pink-500"}>{location.api_token}</code>

            <CopyToClipboard text={location.api_token} onCopy={() => toast.success("Copied to clipboard")}>
              <Icon icon={FaRegCopy} className="cursor-pointer" />
            </CopyToClipboard>
          </div>
          <Divider className="my-3" />
        </>
      )}
      <div>{GLOBAL_STATUS_TITLE_MAP[location.globalStatusCode]}</div>
      {location.globalStatusCode !== PrivateLocationGlobalStatusCode.NOT_REPORTING && (
        <>
          <ListSection listValues={location.warnings} title="Warnings" className={"pulse-color-orange-600"} />
          <ListSection listValues={location.errors} title="Errors" className={"pulse-color-red-600"} />
        </>
      )}
    </FormModal>
  );
};
